<template>
  <div>
    <Chart
      v-if="!isFirstLoad && !error && !isNoData"
      :options="chartOptions"
    />
    <div v-else-if="isFirstLoad" class="sk-three-bounce">
      <div class="sk-child sk-bounce1"></div>
      <div class="sk-child sk-bounce2"></div>
      <div class="sk-child sk-bounce3"></div>
    </div>
    <NoData v-else-if="isNoData"/>
    <ChartError v-else></ChartError>
  </div>
</template>

<script>
  import {cookies} from '../../services/cookies.service';
  import {mapActions, mapGetters, mapState} from "vuex";
  import {Chart} from "highcharts-vue";
  import {HIGHCHARTS_DEFAULTS} from "../../constants";
  import ChartError from "../errors/ChartError";
  import Highcharts from "highcharts";
  import NoData from "../errors/NoData";
  export default {
    name: "FormFactor",
    components: {
      ChartError,
      NoData,
      Chart
    },
    props: ['sitecode', 'loading', 'error', 'lastUpdatedAt'],
    methods: {
      ...mapActions(["fetchFormFactorForChart", "setFilter"]),
      pieColors(color) {
        let colors = [];

        for (let i = 0; i < 10; i++) {
          colors.push(Highcharts.color(color).brighten((i-1) / 9).get());
        }
      return colors;
      }
    },
    mounted() {
      this.fetchFormFactorForChart({sitecode: this.sitecode});
    },
    watch: {
      filters: {
        handler: function () {
          this.fetchFormFactorForChart({sitecode: this.sitecode});
        },
        deep: true,
      },
      sitecode: function (value) {
        this.fetchFormFactorForChart({sitecode: value});
      },
    },
    computed: {
      ...mapGetters(['deviceCountByFormFactorSeries']),
      ...mapState({filters: state => state.api.filters}),
      isFirstLoad() {
        return this.loading && this.lastUpdatedAt == null;
      },
      isNoData() {
        const data = this.deviceCountByFormFactorSeries;
        if (Array.isArray(data) && data.length > 0) {
          return false;
        }
        return true;
      },
      chartOptions: function () {
        return Object.assign({}, HIGHCHARTS_DEFAULTS, {
          colors: this.pieColors("#041E42"),
          chart: {
            type: "pie",
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            events: {
              render: function (chartFormFactor) {

                window.chartFormFactor = chartFormFactor;

                const models = chartFormFactor.target.series[0].data.map(pie => {

                  if (pie.options.name) {

                    /**
                     * @name Cookies
                     * @description Put the model in cookies to be checked by UAT tests
                     */
                    var model = {
                      // pie: pie,
                      id: 'formfactor-' + pie.options.name.replace(new RegExp(' ', 'g'), '-'),
                      name: pie.options.name,
                      value: pie.y,
                      percentage: Math.round(pie.percentage * 10) / 10
                    }

                    cookies.bake(model.id, model);

                    /**
                     * @name ID for pies
                     * @description give an ID to each piec chart to make it easier for UAT to click
                     */
                    pie.graphic.element.id = model.id;

                    return model;
                  }

                });

                console.log('%c formFactor models', 'background:black;color:white;', models);
                cookies.bake('formFactor', models);


              }
            }
          },
          title: {
            text: "Form Factor",
            style: {
              color: '#041E42',
            },
            y: 22,
            x: 15,
          },
          legend: {
            align: "right",
            verticalAlign: "middle",
            layout: "horizverticalontal",
            itemMarginTop: 5,
            itemMarginBottom: 5,
            symbolHeight: 8,
            symbolWidth: 15,
            symbolRadius: 3,
            symbolPadding: 1,
            margin: 1,
            itemStyle: {
              color: "#333333",
              fontWeight: "normal",
              fontSize: "10px"
            },
            labelFormatter: function () {
              return this.name + ' <b>(' + this.y + ')</b>';
            },
            // width: "28%",
          },
          series: [
            {
              innerSize: "45%",
              name: "Number of devices",
              data: this.deviceCountByFormFactorSeries
            }
          ],
          navigation: {
            buttonOptions: {
              y: 8
            }
          },
          plotOptions: {
            pie: {
              size: "80%",
              // allowPointSelect: true,
              dataLabels: {
                enabled: true,
                style: {
                  fontWeight: "bold",
                  fontSize: 10,
                  textOutline: 0
                },
                // format: `
                // <b>{point.name}</b>
                // <br />
                // <p>
                //   {point.percentage:.1f}%
                // </p>`,
                format: "{point.percentage:.1f}%",
                // distance: 50,
                distance: -40,
                filter: {
                  property: "percentage",
                  operator: ">",
                  value: 4
                }
              },
              showInLegend: true
            }
          },
          drilldown: {
            activeDataLabelStyle: {
              color: "#ffffff"
            }
          },
        });
      }
    },
  };
</script>

<style>
  .highcharts-series path {
    cursor: auto !important;
  }

  .highcharts-series rect {
    cursor: auto !important;
  }

  .highcharts-legend g text {
    cursor: auto !important;
  }

  .highcharts-axis-labels text {
    cursor: auto !important;
  }

  .highcharts-label text {
    cursor: auto !important;
  }
</style>
